import { usePunditUserContext } from "@/react/contexts";
import { useIsConnectEnabled } from "@/react/hooks/useIsConnectEnabled";
import { useActiveView } from "@/react/hooks/utils/useActiveView";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { VIEWS } from "@circle-react-shared/MembersList/constants";
import type { MemberDirectorySettings } from "../constants";
import { ControlsDropdown } from "../shared/ControlsDropdown";
import { MemberListWithFilters } from "../shared/MemberListWithFilters";
import { PendingConnections } from "./PendingConnections";
import { Recommendations } from "./Recommendations";

interface AllMembersProps {
  memberDirectorySettings: MemberDirectorySettings;
}

const i18nBase = "members_directory.all_members";

export const AllMembers = ({ memberDirectorySettings }: AllMembersProps) => {
  const [activeView]: any[] = useActiveView({
    defaultCommunityView: memberDirectorySettings.view,
    views: VIEWS,
  });

  const { currentCommunityMember } = usePunditUserContext();

  const isAdmin = isCommunityAdmin(currentCommunityMember);

  const isConnectEnabled = useIsConnectEnabled();

  return (
    <div className="flex flex-col gap-y-10 px-6 pb-20 md:px-2 md:pb-0">
      {isConnectEnabled && (
        <div className="flex flex-col gap-y-8">
          <PendingConnections />

          <Recommendations />
        </div>
      )}

      <MemberListWithFilters
        titleI18nKey={`${i18nBase}.title`}
        memberDirectorySettings={memberDirectorySettings}
        shouldShowHiddenMemberTooltip
        activeView={activeView}
        rightHeaderContent={isAdmin ? <ControlsDropdown /> : null}
      />
    </div>
  );
};
